import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import commonStyles from 'styles/common.pcss';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import {
  Bundle,
  getBundlesDiscountPercent,
} from 'store/ProductDetails/bundles/selectors';


import { BundlePrice } from '../BundlePrice';
import CatIcon from '../../assets/cat.svg';
import styles from './styles.pcss';
const cx = classNames.bind({ ...commonStyles, ...styles });

type BundleBuyContenProps = {
  isMobile: boolean;
  discountPercent: string;
  bundle: Bundle;
};

const BundleBuyContent_ = ({
  isMobile,
  discountPercent,
  bundle,
}: BundleBuyContenProps) => (
  <div className={cx('buy-content-wrapper', isMobile && 'mobile')}>
    <div className={cx('cat', isMobile && 'mobile')}>
      <CatIcon />
    </div>
    {!!discountPercent && (
      <div className={cx('discount')}>
        <Text size="size6-m" color="white">
          {`-${discountPercent}%`}
        </Text>
      </div>
    )}
    <BundlePrice bundle={bundle} />
  </div>
);


const mapStateToProps = state => ({
  isMobile: isScreenBelow800(state),
  discountPercent: getBundlesDiscountPercent(state),
});

export const BundleBuyContent = connect(mapStateToProps)(BundleBuyContent_);

